// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1ls8M","range":"MonthRangeSwitch_range__3sGwM","disabled":"MonthRangeSwitch_disabled__3U9bS"};